import { Page } from '@zocdoc/components/src/Layout';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import CareersPanel from './CareersPanel';
import { CrazyEgg } from '../../Shared/CrazyEgg';
import FindDoctorsPanel from './FindDoctorsPanel';
import Footer from './Footer';
import GetAppPanel from './GetAppPanel';
import { isThemedSearch } from '../experiments/themedSearch';
import { getSignInDropdownText } from '../../config/ab/util';
import JoinPartnersPanel from './JoinPartnersPanel';
import ListPracticePanel from './ListPracticePanel';
import SearchPanel from './SearchPanel';
import { THEMED_SEARCH, SIGNIN_DROPDOWN_TEXT } from '../../config/ab/experiments';
import ThemedSearchPanel from './ThemedSearchPanel';
import { TopPopulatedSpecialtyLinks } from '../../Shared/PopulatedSpecialties';
import withAB from '../../config/ab/withAB';
import { CRAZY_EGG_IDENTIFIERS } from '../../constants';
import PreviousActionTracker from '../../Shared/PreviousActionTracker';

class HomePage extends PureComponent {
    static propTypes = {
        ab: PropTypes.shape({
            experimentId: PropTypes.string,
            defaultAssignment: PropTypes.string,
            isFeatureFlag: PropTypes.bool,
        }),
    };

    static defaultProps = {
        ab: {
            [THEMED_SEARCH.experimentId]: THEMED_SEARCH.defaultAssignment,
            [SIGNIN_DROPDOWN_TEXT.experimentId]: SIGNIN_DROPDOWN_TEXT.defaultAssignment,
        },
    };

    render() {
        return (
            <Page>
                <PreviousActionTracker />
                <SearchPanel
                    isThemedSearch={isThemedSearch(this.props)}
                    signInDropdownText={getSignInDropdownText(this.props)}
                />
                {this.maybeRenderThemedSearchPanel()}
                <GetAppPanel />
                <ListPracticePanel />
                <JoinPartnersPanel />
                <FindDoctorsPanel />
                <CareersPanel />
                <Footer>
                    <TopPopulatedSpecialtyLinks />
                </Footer>
                {this.maybeRenderCrazyEgg()}
            </Page>
        );
    }

    maybeRenderCrazyEgg = () => {
        if (isThemedSearch(this.props)) {
            return (
                <CrazyEgg
                    DesktopSnapshotName={CRAZY_EGG_IDENTIFIERS.ThemedSearch}
                    MobileSnapshotName={CRAZY_EGG_IDENTIFIERS.ThemedSearch}
                    TabletSnapshotName={CRAZY_EGG_IDENTIFIERS.ThemedSearch}
                />
            );
        }
    };

    maybeRenderThemedSearchPanel = () => {
        if (isThemedSearch(this.props)) {
            return (
                <ThemedSearchPanel />
            );
        }
    };
}

export default withAB([THEMED_SEARCH, SIGNIN_DROPDOWN_TEXT])(HomePage);
